import './Notification.scss'
import Button from '../UI/Button.jsx'
import { useEffect, useState } from 'react'

interface NotificationComponentProps {
  closeToast: () => void
  status?: 'success' | 'error' | 'info'
  title: string
  description: string
  acceptText?: string
  acceptHandler?: () => void
  rejectText?: string
  rejectHandler?: () => void
  highlightToken?: number;
  iconSrc?: string;
}

function NotificationComponent({
  closeToast,
  status,
  title,
  description,
  acceptText,
  acceptHandler,
  rejectText,
  rejectHandler,
  highlightToken,
  iconSrc
}: NotificationComponentProps) {
  const [highlight, setHighlight] = useState(false);

  useEffect(() => {
    if (highlightToken) {
      setHighlight(true)
      const timer = setTimeout(() => setHighlight(false), 600)
      return () => clearTimeout(timer)
    }
  }, [highlightToken])

  // Определяем иконку: если передана через props - используем её, иначе - стандартную
  const getIconSrc = () => {
    if (iconSrc) return iconSrc;
    if (status) return `/${status}.svg`;
    return '/info.svg'; // default info icon
  };

  const statusImg = (
    <img src={getIconSrc()} alt={status || 'info'} className="notification-status" />
  )

  const accepttext = acceptText ? acceptText : 'Да'
  const rejecttext = rejectText ? rejectText : 'Нет'

  const dialogButtons = (
    <div className='dialogButtons'>
      <Button contrastStyle className='dialogButton' onClick = {() => {acceptHandler?.(); closeToast(); }}>{accepttext}</Button>
      <Button className='dialogButton' onClick= {() => {rejectHandler?.(); closeToast(); }}>{rejecttext}</Button>
    </div>
  )

  const statusImage = status ? statusImg : null
  const contentDialog = acceptHandler ? dialogButtons : null

  return (
    //<div className="notification">
    <div className={`notification ${highlight ? 'notification-highlight' : ''}`} role="status" aria-live="polite">
      {statusImage}
      <div className="notification-flex">
        <div className="notification-title">
          <div className="notification-title-text">
            {title}
          </div>
          <img
            src="/UI/closeIconBlack.svg"
            alt="closeButton"
            className="notification-title-button"
            onClick={() => closeToast()}
          />
        </div>
        <div className="notification-description">{description}</div>
        {contentDialog}
      </div>
    </div>
  )
}

export default NotificationComponent
